import { Spacer, Stack, Text } from "@chakra-ui/react";
import { Popup } from "react-map-gl";

export interface SubscriberMapPopupProps {
  id?: string;
  lat: number;
  lon: number;
  distance: string;

  source: string;
  /**
   * Name of the subcategory's singular highlighted feature. i.e Brownfield Site, Toxic Release Site, etc.
   */
  singularName: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;

  children?: React.ReactNode;
}

export default function SubscriberMapPopup(props: SubscriberMapPopupProps) {
  return (
    <Popup latitude={props.lat} longitude={props.lon} anchor="top">
      <Stack
        spacing="2"
        bg="white"
        apply="styles.widgetStyles.card"
        px="4"
        py="2"
        borderRadius="md"
      >
        {props?.title && (
          <Text fontWeight="bold" fontSize="md">
            {props?.title}
          </Text>
        )}
        {props?.subtitle && (
          <Text fontSize="sm" color="muted">
            {props?.subtitle}
          </Text>
        )}
        {props.children}
        <Text fontSize="xs" color="subtle">
          <b>{props.singularName}</b> {props.distance}
        </Text>
      </Stack>
    </Popup>
  );
}
